import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a9ee78ae")

_pushScopeId("data-v-a9ee78ae")
const _hoisted_1 = { class: "overlay stat-gender" }
const _hoisted_2 = { class: "t-6 stat-gender__title" }
const _hoisted_3 = { class: "stat-gender__body" }
const _hoisted_4 = { class: "stat-gender__item stat-gender__man" }
const _hoisted_5 = { class: "gender gender--man" }
const _hoisted_6 = { class: "gender__name" }
const _hoisted_7 = { class: "gender__body" }
const _hoisted_8 = {
  key: 0,
  class: "gender__percentage"
}
const _hoisted_9 = { class: "stat-gender__list" }
const _hoisted_10 = { class: "stat-gender__item stat-gender__woman" }
const _hoisted_11 = { class: "gender gender--woman" }
const _hoisted_12 = { class: "gender__name" }
const _hoisted_13 = { class: "gender__body" }
const _hoisted_14 = {
  key: 0,
  class: "gender__percentage"
}
const _hoisted_15 = { class: "stat-gender__list" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('touchbord.gender')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('touchbord.man')), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_svg_icon, { name: "human" })
          ]),
          ($setup.genderValue)
            ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(Math.round($setup.genderValue[1])) + "% ", 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.manArray, (man) => {
            return (_openBlock(), _createBlock(_component_svg_icon, {
              key: man,
              name: "human",
              style: {
              fill: `${man} !important`
            }
            }, null, 8, ["style"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('touchbord.woman')), 1),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_svg_icon, { name: "woman" })
          ]),
          ($setup.genderValue)
            ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(Math.round($setup.genderValue[0])) + "% ", 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_15, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.womanArray, (woman) => {
            return (_openBlock(), _createBlock(_component_svg_icon, {
              key: woman,
              name: "woman",
              style: {
              fill: `${woman} !important`
            }
            }, null, 8, ["style"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
})